<template>
  <div class="text-center">
    <v-dialog v-model="showPopUp" width="500" persistent>
      <F2gCard>
        <v-toolbar color="primary" dark>
          <F2gIcon
            value="protected"
            :height="24"
            :width="24"
            stroke="white"
            :strokeWidth="3"
          />
          <v-toolbar-title>{{ $t("common.sessionExpired") }}</v-toolbar-title>
        </v-toolbar>

        <!-- Body text -->
        <v-card-text>
          <div v-if="!showMfa">
            <div class="item">
              <v-text-field
                v-model="password"
                :error-messages="passwordErrors"
                :label="$t('forms.password')"
                required
                :append-icon="showPassword ? 'visibility' : 'visibility_off'"
                :type="showPassword ? 'text' : 'password'"
                @click:append="showPassword = !showPassword"
                @keyup.enter="eventLogin"
                @input="$v.password.$touch()"
                @blur="$v.password.$touch()"
              ></v-text-field>
            </div>
            <v-alert
              v-model="showError"
              color="error"
              outlined
              v-html="
                $t('errors.incorrectFieldA', { field: $t('forms.password') })
              "
            />
          </div>
          <div v-else>
            <v-layout justify-center>
              <div class="flex-col">
                <div class="text text-center">
                  {{ $t("common.mfaCodeText") }}
                </div>
                <div class="mt-4">
                  <mfaVerificator @validateToken="eventValidateToken" />
                </div>
              </div>
            </v-layout>
          </div>
        </v-card-text>

        <!-- Progress -->
        <div class="flex-row-center" v-if="!showMfa">
          <v-progress-circular
            v-show="auth.status == 'loading'"
            class="progress"
            color="primary"
            indeterminate
          />
        </div>

        <!-- Buttons -->
        <v-card-actions v-if="!showMfa">
          <v-spacer></v-spacer>
          <v-btn
            class="button"
            color="primary"
            text
            @click="eventLogin"
            v-html="$t('common.accept')"
          />
        </v-card-actions>
      </F2gCard>
    </v-dialog>
  </div>
</template>

<script>
import { EventBus } from "@/flit2go-web-core/util/event-bus.js";
import { required } from "vuelidate/lib/validators";
import { mapState, mapActions } from "vuex";
import mfaVerificator from "@/flit2go-web-core/components/ui/mfaVerificator";

export default {
  name: "PopUp-login",
  components: { mfaVerificator },
  validations: {
    password: { required },
  },
  data() {
    return {
      user: "",
      password: "",
      showError: false,
      showPopUp: false,
      showPassword: false,
      showMfa: false,
      mfaToken: null,
    };
  },
  computed: {
    passwordErrors() {
      const errors = [];
      if (this.$v.password.$dirty) {
        !this.$v.password.required &&
          errors.push(
            this.$t("errors.requiredFieldA", {
              field: this.$t("forms.password"),
            })
          );
      }
      return errors;
    },
    ...mapState(["auth"]),
  },

  created() {
    this.user = this.$store.state.auth.userProfile.username;
    EventBus.$on("invalid_token", (value) => {
      this.showPopUp = value;
    });
  },
  methods: {
    ...mapActions({
      getMFALogin: "auth/getMfaLogin",
    }),
    async eventLogin() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.showError = false;

        const hasMfa = await this.hasMFA();

        if (!hasMfa) {
          this.login();
        }
      }
    },

    async hasMFA() {
      return new Promise((resolve) => {
        const payloadMfa = { userName: this.user };

        this.getMFALogin(payloadMfa)
          .then((resp) => {
            this.showMfa = resp.hasMfa;
            resolve(resp.hasMfa);
          })
          .catch((err) => {
            if (err.bannedUser) {
              this.$showMessage.error(err.bannedText);
              // } else { // usuario no existe
              //   this.loading = false;
              //   this.errorMessage = this.$t("error");
              //   // eslint-disable-next-line
              //   grecaptcha.reset();
              //   // eslint-disable-next-line
              //   grecaptcha.execute();
            }
          });
      });
    },

    eventValidateToken(token) {
      this.mfaToken = token;
      this.login();
    },

    login() {
      this.$store
        .dispatch("auth/AUTH_LOGIN", {
          email: this.user,
          password: this.password,
          mfaToken: this.mfaToken,
        })
        .then(() => {
          this.password = "";
          this.passwordRepeat = "";
          this.$v.$reset();
          this.showPopUp = false;
          this.showMfa = false;
          window.location.reload();
        })
        .catch((err) => {
          this.$showMessage.error(err.response.data);
          this.showError = true;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.header {
  background: $success-f2g;
  color: white;
  display: flex;
  flex-direction: row;
  padding-left: 10px;
}
.onion-icon {
  width: 30px;
  height: 30px;
  align-self: center;
  cursor: pointer;

  use {
    stroke-width: 1;
    stroke: white;
  }
}
.item {
  display: flex;
  flex-direction: row;

  .v-input {
    width: 60%;
  }
}

.progress {
  margin-left: 40%;
}
</style>
